import { render, staticRenderFns } from "./WelcomeScreenDesignConfig.vue?vue&type=template&id=353ea27b&"
import script from "./WelcomeScreenDesignConfig.vue?vue&type=script&lang=js&"
export * from "./WelcomeScreenDesignConfig.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeScreenDesignConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports